'use client';
import React from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

interface StrapiBlocksRendererProps {
  blocks: any[] | any | string | null | undefined;
  className?: string;
}

const StrapiBlocksRenderer: React.FC<StrapiBlocksRendererProps> = ({ 
  blocks, 
  className = '' 
}) => {
  // Validación más robusta para diferentes tipos de datos
  if (!blocks) {
    return null;
  }


  // Si blocks no es un array, intentar convertirlo o retornar null
  let validBlocks: any[];
  
  if (Array.isArray(blocks)) {
    validBlocks = blocks;
  } else if (typeof blocks === 'string') {
    // Si es un string, renderizar como texto plano
    return <div data-component-id="src/components/ui/StrapiBlocksRenderer.tsx:27:11" data-component-path="src/components/ui/StrapiBlocksRenderer.tsx" data-component-line="27" data-component-file="StrapiBlocksRenderer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" className={className}>{blocks}</div>;
  } else if (typeof blocks === 'object' && blocks !== null) {
    // Si es un objeto, intentar extraer propiedades relevantes
    validBlocks = [blocks];
  } else {
    // Caso por defecto: retornar null para tipos no soportados
    console.warn('StrapiBlocksRenderer: blocks debe ser un array, string u objeto:', blocks);
    return null;
  }

  // Verificar que el array no esté vacío
  if (validBlocks.length === 0) {
    return null;
  }

  return (
    <div data-component-id="src/components/ui/StrapiBlocksRenderer.tsx:43:4" data-component-path="src/components/ui/StrapiBlocksRenderer.tsx" data-component-line="43" data-component-file="StrapiBlocksRenderer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" className={className}>
      <BlocksRenderer data-component-id="src/components/ui/StrapiBlocksRenderer.tsx:44:6" data-component-path="src/components/ui/StrapiBlocksRenderer.tsx" data-component-line="44" data-component-file="StrapiBlocksRenderer.tsx" data-component-name="BlocksRenderer" data-component-content="%7B%22elementName%22%3A%22BlocksRenderer%22%7D" content={validBlocks} />
    </div>
  );
};

export default StrapiBlocksRenderer;
